// Ported from peerception-excel-add-in-modelling (itself from the webapp): cookie-based auth so
// the backend can set tokens on the parent domain (PLAN-agent-v2 §1.3).
//
// These are the raw cookie primitives. Auth code must NOT call them directly — go through
// `tokenStore.ts`, which treats the cookie as preferred-but-not-load-bearing because Office
// silently drops it in a cross-site frame. See the header of that file.

export function setCookie(name: string, value: string, days = 1): void {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = '; expires=' + date.toUTCString();
  // Office may host the taskpane in a cross-site iframe, where Chromium's implicit
  // `SameSite=Lax` default makes the write a silent no-op. `SameSite=None` requires
  // `Secure`, which requires HTTPS — so only set the pair when the page is actually
  // secure, otherwise plain http dev servers would reject every cookie.
  const crossSite = location.protocol === 'https:' ? '; SameSite=None; Secure' : '';
  document.cookie = name + '=' + (value || '') + expires + '; path=/' + crossSite;
}

export function getCookie(name: string): string | null {
  const nameEQ = name + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

export function removeCookie(name: string): void {
  document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  const parts = window.location.hostname.split('.');
  if (parts.length > 2) {
    const parentDomain = '.' + parts.slice(1).join('.');
    document.cookie =
      name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=' + parentDomain + ';';
  }
}

export function clearAllCookies(): void {
  const cookies = document.cookie.split(';');
  const hostname = window.location.hostname;
  const parts = hostname.split('.');
  const parentDomain = parts.length > 2 ? '.' + parts.slice(1).join('.') : '';

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name.trim() + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;';
    if (parentDomain) {
      document.cookie =
        name.trim() + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=' + parentDomain + ';';
    }
  }
}
